import PodRoomPrevButton from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomPrevButton.vue'

export default {
  components : {
    PodRoomPrevButton
  },

  data(){
    return {
      isLoadingPrevButton : false
    };
  },

  methods : {
    async handleListPrevButtonClick(room){
      this.isLoadingPrevButton = true;

      await this.UXWaiting(500);

      if(!(this.currentPage >= this.lastPage)){
        const nextPage = (this.currentPage + 1);

        // console.log('[PULL TO: PodRoom => '+this.podRoomId+' PAGE: '+nextPage+']');

        this.$store.dispatch({
          type        : 'connection/updatePodRoomData',
          podRoomId   : room.id,
          page        : nextPage,
          currentPage : nextPage
        });

        await this.waitLoading(
          this.$apollo.queries.podMessages.loading, 1000, 5
        );
      }

      this.isLoadingPrevButton = false;
    }
  }
}